import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import '../../../pages/proposal/styles.less'
import { Table, Row } from 'rsuite'
import { cloneDeep } from 'lodash-es'
import AttachFilesView from '../../attachfiles/AttachFilesView'
import { getDownload } from '../../../redux/actions/projectManagement'
import { startLoading, doneLoading } from '../../../utils/loading'
import ProjectManageStructureTableForm from './ProjectManageStructureTableForm'

export default function ProjectManageStructureView({ schema: _schema, ...props }) {
  const { Column, HeaderCell, Cell } = Table
  const { onDownload, onPreview } = props
  const [schema, setSchema] = useState(_schema)
  const [dataList, setDataList] = useState([])
  const [src, setSrc] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    // console.log('useEffect schema', schema)
    groupByRole(_schema.role.value)
  }, [_schema])

  const groupByRole = (_dataList) => {
    let roleNameOptions = cloneDeep([...schema.roleOptions])
    let sum = 0
    // console.log('groupByRole schema', _dataList)
    // console.log('roleNameOptions', roleNameOptions)

    schema?.roleOptions?.forEach((element, index) => {
      let count = 0
      _dataList.forEach((item) => {
        // console.log('element', element, 'item', item)
        if (element.value == item.roleCode) {
          count++
        }
      })

      sum += count
      // console.log('roleNameOptions[index]', roleNameOptions[index], 'count', count)
      roleNameOptions[index]['number'] = count
    })

    let sumRow = {
      value: '',
      label: '',
      sumPeople: sum,
      sumLabel: 'รวม',
      isSum: true,
    }
    roleNameOptions.push(sumRow)

    setDataList(roleNameOptions)
  }

  return (
    <div>
      <div>
        <Table autoHeight data={dataList} className="project-management-structure-table">
          <Column width={120} align="center">
            <HeaderCell className="project-management-structure-header-nowrap">ข้อที่</HeaderCell>
            <Cell>
              {(rowData, index) => {
                if (rowData.isSum) {
                  return <span></span>
                } else return <span>{index + 1}</span>
              }}
            </Cell>
          </Column>
          <Column flexGrow={1}>
            <HeaderCell>บทบาทหน้าที่</HeaderCell>
            <Cell dataKey="label" />
          </Column>

          <Column width={120} align="center">
            <HeaderCell></HeaderCell>
            <Cell dataKey="sumLabel" />
          </Column>

          <Column width={120} align="center">
            <HeaderCell>จำนวน (คน)</HeaderCell>
            <Cell>
              {(rowData, index) => {
                if (rowData.isSum) {
                  return <span>{rowData.sumPeople}</span>
                } else return <span>{rowData.number}</span>
              }}
            </Cell>
          </Column>
        </Table>
      </div>

      <ProjectManageStructureTableForm
        schema={schema.role}
        isEdit={false}
        // handleDelete={onDelete}
        // handleEdit={handleEdit}
      />

      <Row>
        <hr />
        <Row style={{ marginTop: 10, marginLeft: 10 }}>
          <p> {schema.attachFiles.description[0]} </p>
        </Row>
        <AttachFilesView
          schema={schema.attachFiles}
          autoHeight={true}
          onDownload={onDownload}
          onPreview={onPreview}
        />
      </Row>
    </div>
  )
}
